import axios from "axios";
import Cookies from "js-cookie";

// const API = axios.create({ baseURL: process.env.REACT_APP_SERVER_URL });
const baseURL = process.env.REACT_APP_SERVER_URL || "http://192.168.1.3:5000/";
const API = axios.create({
  baseURL: baseURL,
});
API.interceptors.request.use((req) => {
  const isSessionActive = Cookies.get("user_token");
  if (isSessionActive) {
    req.headers.Authorization = `Bearer ${isSessionActive}`;
  }
  return req;
});
export default API;
